export const BASE_URL = 'https://vrdentalbackend.vrdenta.com/api';
//export const BASE_URL = 'http://localhost:5000/api';